import classNames from "classnames";
import React from "react";

export type CaTableHeaderProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLTableSectionElement>,
  HTMLTableSectionElement
>;

function CaTableHeader({ className, ...props }: CaTableHeaderProps) {
  return <thead className={classNames("[&_tr]:border-b", className)} {...props} />;
}

export default CaTableHeader;
